<template>
  <div
    :class="{ mastery: isMasteryApp, masteryHeader: masteryHeader, topbarOnly: !showBreadcrumbs }"
    class="page-header-component-container"
  >
    <div
      class="topbar"
    >
      <slot name="topbar" />
    </div>
    <breadcrumbs
      v-if="showBreadcrumbs"
      :breadcrumbs="breadcrumbs"
    >
      <template v-slot:right>
        <slot name="breadcrumbSlot" />
      </template>
      <template v-slot:floatRight>
        <slot name="breadcrumbFloatRight" />
      </template>
    </breadcrumbs>
    <rate-limit-counter-container
      v-if="showRateLimitCounter"
    />
  </div>
</template>

<script>
import Breadcrumbs from '@components/singletons/breadcrumbs';
import RateLimitCounterContainer from '@components/banners/RateLimitCounterContainer';

export default {
  components: { Breadcrumbs, RateLimitCounterContainer },
  props: {
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
    showBreadcrumbs: {
      type: Boolean,
      default: true,
    },
    showRateLimitCounter: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isMasteryApp() {
      return this.$store.getters['app/isMasteryApp'];
    },
    masteryHeader() {
      return this.$route && this.$route.meta.masteryHeader;
    },
  },
};
</script>
<style lang='scss' scoped>
.page-header-component-container {
  background: $white-1;
  box-shadow: 0 1px 2px 0 rgba(0,0,0,0.25);
  top: rem-calc(48);
  height: rem-calc(109);
  left: rem-calc(220);
  position: fixed;
  right: 0;
  z-index: 11;

  @include breakpoint(small) {
    left: 0;
    top: rem-calc(72);
  }

  &.mastery {
    left: rem-calc(88);

    @include breakpoint(small) {
      left: 0;
      position: absolute;
    }
  }

  &.masteryHeader {
    height: rem-calc(45);

    // just display breadcrumbs
    .topbar {
      display: none;
    }
  }

  &.topbarOnly {
    height: auto;
  }

  .topbar {
    align-items: center;
    border-bottom: 1px solid $grey-4;
    box-sizing: border-box;
    display: flex;
    height: rem-calc(64);
    padding: 0 rem-calc(48);
    width: 100%;

    @include breakpoint(small) {
      padding: 0 rem-calc(16);
    }

    h1 {
      color: #354052;
      flex: 1;
      font-size: rem-calc(18);
      font-weight: $normal;
    }

    .progress {
      align-items: center;
      display: flex;

      .counter {
        color: #354052;
        font-size: rem-calc(11);
        font-weight: $semi-bold;
        margin-right: rem-calc(8);
      }
    }
  }
}
</style>
